import { gql } from '@urql/core';

import { globalFeatureKeys } from '/src/features/_global/queries';
import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';
import { requestUserDataRefresh } from '/src/services/user-data-refresh';

export const setUserDataMutation = ({ client, queryClient }) => ({
  mutationFn: ({ name, value }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation SetUserData($name: String!, $value: String) {
          setUserData(name: $name, value: $value)
        }
      `,
      {
        name,
        value,
      },
    ),
  onSuccess: async (_data, variables) => {
    queryClient.invalidateQueries({ ...globalFeatureKeys.userData });
    if (variables?.refreshUserData !== false) {
      try {
        await requestUserDataRefresh();
      } catch (error) {
        console.error('Failed to refresh user data after setUserData mutation', error);
        queryClient.invalidateQueries({ ...globalFeatureKeys.userData });
      }
    }
  },
});

export const setSiteColors = ({ client, queryClient }) => ({
  mutationFn: ({ siteId, colors }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation SetSiteColors($siteId: Int!, $colors: [String]!) {
          setSiteColors(siteId: $siteId, colors: $colors) {
            id
            name
            metadata
          }
        }
      `,
      {
        siteId,
        colors,
      },
    ),
  onSuccess: () => {
    return queryClient.invalidateQueries({ queryKey: ['sites'] });
  },
});
